import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useVestigioService } from 'hooks/useVestigioService'
import { useCestaOperacaoLote } from 'hooks/useCestaOperacaoLote'

export const useGuardarVestigio = () => {
  const params = useParams()
  const router = useRouter()
  const vestigioService = useVestigioService()
  const { setReloadSelecionados } = useCestaOperacaoLote()

  const [vestigio, setVestigio] = useState({})
  const [carregando, setCarregando] = useState(true)
  const [isProcessando, setIsProcessando] = useState(false)

  const fetchVestigio = useCallback(async () => {
    setCarregando(true)
    const data = await vestigioService.listarVestigioAsync(params.id)
    setVestigio(data)
    setCarregando(false)
  }, [params.id])

  const handleConfirmGuardarVestigio = useCallback(async (formValues) => {
    await vestigioService.guardarVestigio(params.id, formValues, setIsProcessando)
    setReloadSelecionados(true)
    router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
  }, [params.id, setReloadSelecionados, router])

  const handleCancelar = useCallback(() => {
    router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
  }, [params.id, router])

  useEffect(() => {
    fetchVestigio()
  }, [fetchVestigio])

  return {
    vestigio,
    carregando,
    isProcessando,
    handleConfirmGuardarVestigio,
    handleCancelar,
  }
}
